import React, { useEffect, useState } from 'react'
import Select from "react-select";

// custom components
import { CustomSpinner, ColorPicker } from "_atoms";
import LocationBeaconForm from "./location-beacon-form";

// tremor
import { Title, Subtitle, Flex } from "@tremor/react";

// bootstrap
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// styling
import { Colors, Spacing } from "_styles";

//redux
import { useSelector, useDispatch } from "react-redux";
import {
    selectAllTimelineAreas,
    selectSelectedAirportLocation,
    selectAddAirportLocationsStatus,
    selectEditAirportLocationsStatus,
    setSelectedAirportLocation,
    addAirportLocation,
    editAirportLocation,
    selectAllAirportLocations
} from "_redux/slices/timeline/timeline-areas";
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";
import { getAirportUuidAndCoordinates, SelectAirportUuid } from "_redux/slices/timeline/timeline-live-location-tab";

// live location map
import LiveLocationMap from "_scenes/portal/timeline/live-locations-components/live-location-map";
import { useIsMobile } from "_utils/hooks";

const HandleAirportLocationForm = ({ closeModal }) => {

    //#region redux states
    const dispatch = useDispatch();

    const timelineAreas = useSelector(selectAllTimelineAreas);                                    // select all timelineAreas
    const airportLocations = useSelector(selectAllAirportLocations);                                 // select all airport locations
    const selectedAirportLocation = useSelector(selectSelectedAirportLocation)                    // selected airport location to edit or delete
    const addAirportLocationsStatus = useSelector(selectAddAirportLocationsStatus)                // add airport locations Status
    const editAirportLocationsStatus = useSelector(selectEditAirportLocationsStatus)              // edit airport locations Status
    const dbUser = useSelector(selectFirebaseInfo);
    const airportUuid = useSelector(SelectAirportUuid);
    const canMergeLocations = ["ADMIN", "GARETH"].includes(dbUser?.role);                          // only admins can list a location under another location
    const isMobile = useIsMobile();                                                               // phones: no fixed-height box around the map

    //#endregion

    //#region local states
    const [title, setTitle] = useState("");                                                       // holds airport location title
    const [nickname, setNickname] = useState("");                                                 // holds airport location nickname
    const [selectedArea, setSelectedArea] = useState("");                                         // holds selected timeline area
    const [errors, setErrors] = useState(null);
    const [gate, setGate] = useState("");                                                         // holds gate number
    const [stand, setStand] = useState("");                                                       // holds stand number
    const [paxBoardType, setPaxBoardType] = useState("");                                         // holds passenger boarding type(Air Bridge or Ramp)
    const [selectedColor, setSelectedColor] = useState("");                                       // holds selected color
    const [beaconDetails, setBeaconDetails] = useState([]);                                       // holds beacon details
    const [selectPaxType, setSelectPaxType] = useState("Both");
    const [locationType, setLocationType] = useState("Other");
    const [gateStands, setGateStands] = useState([]);                                              // holds selected stands
    const [terminal, setTerminal] = useState("");                                                   // holds selected terminal
    const [level, setLevel] = useState("");                                                         // holds selected level
    const [landsideAirside, setLandsideAirside] = useState("");                                     // holds landside or airside
    const [geofenceType, setGeofenceType] = useState(null);
    const [geofence, setGeofence] = useState(null);                                                 // geofence GeoJSON object
    const [polygon, setPolygon] = useState([]);
    const [circularGeofence, setCircularGeofence] = useState({});
    const [displayUnderLocationId, setDisplayUnderLocationId] = useState("");                       // list this location's passengers under another location in the Locations tab
    //#endregion

    //#region useEffect

    // check if it is edit, fill the title, selectedArea, beacon details, geofence radius with the selected airport location
    useEffect(() => {
        console.log(selectedAirportLocation)
        if (!Object.isObjectEmpty(selectedAirportLocation)) {
            setTitle(selectedAirportLocation?.title)
            if (selectedAirportLocation?.nickname) setNickname(selectedAirportLocation?.nickname);
            // check if the timelineId in selectedAirportLocation is a type of string
            if (typeof selectedAirportLocation?.timelineId === "string") {
                let tempArea = timelineAreas?.filter((area) => area?._id === selectedAirportLocation?.timelineId);
                if (Array.isFullArray(tempArea)) {
                    setSelectedArea([{ label: tempArea?.[0]?.title, value: tempArea?.[0]?._id }])
                } else setSelectedArea([])
            } else {
                if (Array.isFullArray(selectedAirportLocation?.timelineId)) {
                    let tempArea = timelineAreas?.filter((area) => selectedAirportLocation?.timelineId?.includes(area?._id));
                    if (Array.isFullArray(tempArea)) {
                        setSelectedArea(tempArea.map((area) => { return { label: area?.title, value: area?._id } }));
                    } else setSelectedArea([]);
                } else setSelectedArea([]);
            }
            if (selectedAirportLocation?.pickUp) setSelectPaxType("Pick Up")
            else if (selectedAirportLocation?.dropOff) setSelectPaxType("Drop Off")
            else setSelectPaxType("Both")
            if (selectedAirportLocation?.gate) setGate(selectedAirportLocation?.gate);
            if (selectedAirportLocation?.stand) setStand(selectedAirportLocation?.stand);
            if (selectedAirportLocation?.locationType) setLocationType(selectedAirportLocation?.locationType);
            if (selectedAirportLocation?.gateStands) setGateStands(selectedAirportLocation?.gateStands);
            if (selectedAirportLocation?.terminal) setTerminal({ label: selectedAirportLocation?.terminal, value: selectedAirportLocation?.terminal });
            if (selectedAirportLocation?.level) setLevel({ label: selectedAirportLocation?.level, value: selectedAirportLocation?.level });
            if (selectedAirportLocation?.landsideAirside) setLandsideAirside(selectedAirportLocation?.landsideAirside);
            setDisplayUnderLocationId(selectedAirportLocation?.displayUnderLocationId ?? "");

            if (selectedAirportLocation?.paxBoardType === "ramp") setPaxBoardType("ramp");
            else if (selectedAirportLocation?.paxBoardType === "airBridge") setPaxBoardType("airBridge");
            else setPaxBoardType("")
            if (selectedAirportLocation?.color) setSelectedColor(selectedAirportLocation?.color);

            // add beacon details and geofence to edit modal
            if (selectedAirportLocation?.beaconDetails) setBeaconDetails(selectedAirportLocation?.beaconDetails);
            if (selectedAirportLocation?.geofenceDetails) {

                if (!selectedAirportLocation?.geofenceDetails?.type) return;

                setGeofenceType(selectedAirportLocation?.geofenceDetails?.type);

                if (selectedAirportLocation?.geofenceDetails?.type === "polygon" && selectedAirportLocation?.geofenceDetails?.polygon.length > 2) {
                    setPolygon(selectedAirportLocation?.geofenceDetails?.polygon);
                }
                else {
                    setCircularGeofence(selectedAirportLocation?.geofenceDetails?.circular);
                }
            }
        }
    }, [selectedAirportLocation])

    useEffect(() => {
        dispatch(getAirportUuidAndCoordinates(dbUser?.details.authority));
    }, []);
    //#endregion

    //#region functions

    // check that title is not empty and does not exist in the airport locations
    const handleChangeZoneTitle = (value) => {
        setTitle(value);
        // check if the entered zone title already exists
        let isTitleExist = airportLocations?.filter((row) => row?.title?.trim() == value?.trim());
        if (isTitleExist?.length > 0) { setErrors("Dorp off location title already exists!"); return; }

        // reset titleError
        setErrors(null);
    };

    // close modal
    const handleCancelButton = () => {
        closeModal();
        dispatch(setSelectedAirportLocation(null));
    };

    // convert the locations into array of objects {label, value } for the Select
    const transformToObject = (areasArray) => {
        return Array.isFullArray(areasArray)
            ? areasArray?.map((location) => { return { label: location?.title, value: location?._id } })
            : [];
    };

    const handleConfirm = () => {

        if (!title.length) { setErrors("Title is required!") };
        let data = {
            iata: dbUser.details.authority,
            body: {
                iata: dbUser.details.authority,
                title: title?.trim(),
                nickname: nickname?.trim(),
                timelineId: Array.isFullArray(selectedArea) ? selectedArea?.map((area) => area?.value) : [],
                pickUp: selectPaxType == "Pick Up",
                dropOff: selectPaxType == "Drop Off",
                both: selectPaxType == "Both",
                gate: gate,
                stand: stand,
                paxBoardType: paxBoardType,
                color: selectedColor,
                // uuid: beaconUuid,
                // beaconMajor: beaconMajor,
                // beaconMinor: beaconMinor,
                locationType: locationType,
                gateStands: gateStands,
                terminal: terminal?.value ?? "",
                level: level?.value ?? "",
                landsideAirside: landsideAirside,
                // omitted for non-admins so saving never changes it
                ...(canMergeLocations && { displayUnderLocationId: displayUnderLocationId || null }),
                beaconDetails: beaconDetails.map((beacon) => ({
                    uuid: airportUuid,
                    beaconId: beacon.beaconId,
                    nickname: beacon.nickname,
                    major: beacon.major,
                    minor: beacon.minor,
                    notes: beacon.notes,
                    beaconPlacement: beacon.beaconPlacement,
                    iBeaconMacAddress: beacon.iBeaconMacAddress,
                })),
                geofenceDetails: {
                    type: geofenceType,
                    polygon: polygon,
                    circular: circularGeofence
                },
            },
        };


        // if selectedAirportLocation is not empty then it is edit
        if (!Object.isObjectEmpty(selectedAirportLocation)) {
            delete data.iata
            data["id"] = selectedAirportLocation._id;
            dispatch(editAirportLocation(data))
        }
        else {
            // need to create new airport location
            dispatch(addAirportLocation(data));
        }

    };

    const handleChangeLocationType = (value) => {
        setGateStands([]);
        setGate(selectedAirportLocation?.gate ?? "");
        setStand(selectedAirportLocation?.stand ?? "");
        setLocationType(value);
    };

    //#endregion

    return (
        <div>

            <div style={{}}>

                {/* location name / title / color */}
                <Row>

                    {/* location name */}
                    <Col xs={12} md={6}>

                        {/* location name */}
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", justifyContent: "space-between" }}>
                            <p style={{ margin: 0, padding: 0, height: "24px" }}>Location Title</p>
                            <p style={{ color: "red", margin: 0, padding: 0, height: "24px", fontSize: 12 }}>{"* Required"}</p>
                        </Form.Label>

                        <Subtitle>The name of the location you are saving</Subtitle>

                        <Form.Control
                            onChange={(e) => { handleChangeZoneTitle(e.target.value) }}
                            style={{ borderColor: errors ? "red" : null }}
                            type="name"
                            placeholder="Enter airport location title"
                            value={title}
                            className='mt-2'
                        />
                        {errors && <div style={{ color: "red" }}>{errors}</div>}

                    </Col>

                    {/* location nickname */}
                    <Col xs={12} md={6} className='mt-3 mt-md-0'>

                        {/* location nickname */}
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", justifyContent: "space-between" }}>
                            <p style={{ margin: 0, padding: 0, height: "24px" }}>Location Nickname</p>
                            <p style={{ color: 'grey', margin: 0, padding: 0, height: "24px", fontSize: 12 }}>{"(Optional)"}</p>
                        </Form.Label>

                        <Subtitle>Name used by staff rather than the full official title.</Subtitle>

                        <Form.Control
                            onChange={(e) => { setNickname(e.target.value) }}
                            type="name"
                            placeholder="Enter airport location nickname"
                            value={nickname}
                            className='mt-2'
                        />

                    </Col>

                </Row>

                {/* display under another location (admin only) */}
                {canMergeLocations && <Row className='mt-4'>
                    <Col xs={12} md={6}>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", justifyContent: "space-between" }}>
                            <p style={{ margin: 0, padding: 0, height: "24px" }}>Show Under Location</p>
                            <p style={{ color: 'grey', margin: 0, padding: 0, height: "24px", fontSize: 12 }}>{"(Optional)"}</p>
                        </Form.Label>
                        <Subtitle>Passengers here are listed under the selected location in the Locations tab, tagged with this location's name. Their actual location does not change.</Subtitle>
                        <Select
                            isClearable
                            className="mt-2"
                            classNamePrefix="select"
                            placeholder="Show as its own location"
                            options={(airportLocations ?? [])
                                .filter((location) => location?._id !== selectedAirportLocation?._id && !location?.displayUnderLocationId)
                                .map((location) => ({ label: location?.title, value: location?._id }))}
                            value={(() => {
                                const target = airportLocations?.find((location) => location?._id === displayUnderLocationId);
                                return target ? { label: target?.title, value: target?._id } : null;
                            })()}
                            onChange={(selection) => setDisplayUnderLocationId(selection?.value ?? "")}
                        />
                    </Col>
                </Row>}

                {/* location type */}
                <Row className='mt-5'>
                    <Col xs={12} md={6} className='mt-3'>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", justifyContent: "space-between" }}>
                            <p style={{ margin: 0, padding: 0, height: "24px" }}>Location Type</p>
                            <p style={{ color: "red", margin: 0, padding: 0, height: "24px", fontSize: 12 }}>{"* Required"}</p>
                        </Form.Label>
                        <Subtitle>Select the type of this location</Subtitle>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Form.Check className='d-flex gap-2 align-items-center' type="radio" label={"Gate"} checked={locationType == "Gate"} onChange={() => handleChangeLocationType("Gate")} />
                            <Form.Check className='d-flex gap-2 align-items-center' type="radio" label={"Stand"} checked={locationType == "Stand"} onChange={() => handleChangeLocationType("Stand")} />
                            <Form.Check className='d-flex gap-2 align-items-center' type="radio" label={"Other"} checked={locationType == "Other"} onChange={() => handleChangeLocationType("Other")} />
                        </div>
                    </Col>
                </Row>

                {/* gate */}
                {locationType == "Gate" && (
                    <Row>
                        <Col>
                            <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", justifyContent: "space-between", marginTop: Spacing.SCALE_10 }}>
                                <p style={{ margin: 0, padding: 0, height: "24px" }}>Gate</p>
                                <p style={{ color: 'grey', margin: 0, padding: 0, height: "24px", fontSize: 12 }}>{"(Optional)"}</p>
                            </Form.Label>
                            <Subtitle>The corresponding gate for this location</Subtitle>
                            <Form.Control onChange={(e) => { setGate(e.target.value) }} type="name" placeholder="Enter the gate number at this location" value={gate} className='mt-2' />
                        </Col>
                        <Col>
                            <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", justifyContent: "space-between", marginTop: Spacing.SCALE_10 }}>
                                <p style={{ margin: 0, padding: 0, height: "24px" }}>Stands</p>
                                <p style={{ color: 'grey', margin: 0, padding: 0, height: "24px", fontSize: 12 }}>{"(Optional)"}</p>
                            </Form.Label>
                            <Subtitle>The corresponding stands for this Gate</Subtitle>
                            <Select isMulti options={transformToObject(airportLocations?.filter((location) => location?.locationType == "Stand"))} className="basic-multi-select mt-2" classNamePrefix="select" onChange={(selection) => {
                                setGateStands(selection)
                            }} value={gateStands} />
                        </Col>

                    </Row>
                )}

                {/* stand */}
                {locationType == "Stand" && (
                    <Row>
                        <Col>
                            <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", justifyContent: "space-between", marginTop: Spacing.SCALE_10 }}>
                                <p style={{ margin: 0, padding: 0, height: "24px" }}>Stand</p>
                                <p style={{ color: 'grey', margin: 0, padding: 0, height: "24px", fontSize: 12 }}>{"(Optional)"}</p>
                            </Form.Label>
                            <Subtitle>The corresponding stand for this location</Subtitle>
                            <Form.Control onChange={(e) => { setStand(e.target.value) }} type="name" placeholder="Enter the stand number at this location" value={stand} className='mt-2' />
                        </Col>

                    </Row>
                )}


                {/* timeline area */}
                <Row>
                    <Form.Label className='mt-5' style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", justifyContent: "space-between" }}>
                        <p style={{ margin: 0, padding: 0, height: "24px" }}>Timeline Area</p>
                        <p style={{ color: 'grey', margin: 0, padding: 0, height: "24px", fontSize: 12 }}>{"(Optional)"}</p>
                    </Form.Label>
                    <Subtitle>Select the airport areas where this location is used. Flights that match the gate or stand linked to this location will appear in the job list within the timeline view for those areas.</Subtitle>
                    <Select
                        isMulti
                        options={transformToObject(timelineAreas)}
                        className="basic-multi-select mt-3"
                        classNamePrefix="select"
                        onChange={(selection) => { setSelectedArea(selection) }} value={selectedArea} />
                </Row>

                {/* terminal + level */}
                <Row className='mt-5'>
                    <Col xs={12} md={6}>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", justifyContent: "space-between" }}>
                            <p style={{ margin: 0, padding: 0, height: "24px" }}>Terminal</p>
                            <p style={{ color: "red", margin: 0, padding: 0, height: "24px", fontSize: 12 }}>{"* Required"}</p>
                        </Form.Label>
                        <Subtitle>Select the airport terminal the location is situated.</Subtitle>
                        <Select
                            options={[
                                { label: "Terminal 1", value: "Terminal 1" },
                                { label: "Terminal 2", value: "Terminal 2" }
                            ]}
                            className="basic-select mt-3"
                            classNamePrefix="select"
                            onChange={(selection) => { setTerminal(selection) }}
                            value={terminal}
                            isClearable
                        />
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", justifyContent: "space-between" }}>
                            <p style={{ margin: 0, padding: 0, height: "24px" }}>Level</p>
                            <p style={{ color: "red", margin: 0, padding: 0, height: "24px", fontSize: 12 }}>{"* Required"}</p>
                        </Form.Label>
                        <Subtitle>Select the level where this location is situated.</Subtitle>
                        <Select
                            options={[
                                { label: "G", value: "G" },
                                { label: "1", value: "1" },
                                { label: "2", value: "2" },
                                { label: "3", value: "3" },
                                { label: "4", value: "4" },
                                { label: "5", value: "5" }
                            ]}
                            className="basic-select mt-3"
                            classNamePrefix="select"
                            onChange={(selection) => { setLevel(selection) }}
                            value={level}
                            isClearable
                        />
                    </Col>
                </Row>

                {/* landside / airside */}
                <Row className='mt-5'>
                    <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", justifyContent: "space-between" }}>
                        <p style={{ margin: 0, padding: 0, height: "24px" }}>Landside / Airside</p>
                        <p style={{ color: "red", margin: 0, padding: 0, height: "24px", fontSize: 12 }}>{"* Required"}</p>
                    </Form.Label>
                    <Subtitle>Select whether this location is landside or airside.</Subtitle>
                    <Col xs={12} md={6} className='mt-3' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Form.Check className='d-flex gap-2 align-items-center' type="radio" label={"Landside"} checked={landsideAirside == "Landside"} onChange={() => setLandsideAirside("Landside")} />
                        <Form.Check className='d-flex gap-2 align-items-center' type="radio" label={"Airside"} checked={landsideAirside == "Airside"} onChange={() => setLandsideAirside("Airside")} />
                    </Col>
                </Row>

                {/* passenger types */}
                <Row className='mt-5'>
                    <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", justifyContent: "space-between", marginTop: Spacing.SCALE_10 }}>
                        <p style={{ margin: 0, padding: 0, height: "24px" }}>Passenger Types</p>
                        <p style={{ color: "red", margin: 0, padding: 0, height: "24px", fontSize: 12 }}>{"* Required"}</p>
                    </Form.Label>
                    <Subtitle>Select the different types of passengers that can be assisted in this location. This will only allow these types of passengers to be dropped off at this location.</Subtitle>
                    <Col xs={12} md={6} className='mt-3' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Form.Check className='d-flex gap-2 align-items-center' type="radio" label={"Pick Up"} checked={selectPaxType == "Pick Up"} onChange={() => setSelectPaxType("Pick Up")} />
                        <Form.Check className='d-flex gap-2 align-items-center' type="radio" label={"Drop Off"} checked={selectPaxType == "Drop Off"} onChange={() => setSelectPaxType("Drop Off")} />
                        <Form.Check className='d-flex gap-2 align-items-center' type="radio" label={"Both"} checked={selectPaxType == "Both"} onChange={() => setSelectPaxType("Both")} />
                    </Col>
                </Row>

                {/* passenger boarding types */}
                <Row className='mt-5'>
                    <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", justifyContent: "space-between", marginTop: Spacing.SCALE_10 }}>
                        <p style={{ margin: 0, padding: 0, height: "24px" }}>Boarding Types</p>
                        <p style={{ color: "red", margin: 0, padding: 0, height: "24px", fontSize: 12 }}>{"* Required"}</p>
                    </Form.Label>
                    <Subtitle>Select the passenger boarding type to airplane in this location</Subtitle>
                    <Col xs={12} md={6} style={{ display: 'flex', justifyContent: 'space-between' }} className='mt-3'>
                        <Form.Check className='d-flex gap-2 align-items-center' type="radio" label={"Ramp"} checked={paxBoardType == "ramp"} onChange={() => setPaxBoardType("ramp")} />
                        <Form.Check className='d-flex gap-2 align-items-center' type="radio" label={"Air Bridge"} checked={paxBoardType == "airBridge"} onChange={() => setPaxBoardType("airBridge")} />
                        <Form.Check className='d-flex gap-2 align-items-center' type="radio" label={"None"} checked={paxBoardType == ""} onChange={() => setPaxBoardType("")} />
                    </Col>
                </Row>

                {/* beacon details */}
                <LocationBeaconForm
                    beaconDetails={beaconDetails}
                    setBeaconDetails={setBeaconDetails}
                    airportUuid={airportUuid}
                    initialBeaconDetails={selectedAirportLocation?.beaconDetails}
                />

                {/* location color */}
                <Row className='mt-5'>

                    {/* location color */}
                    <Col>

                        {/* location color */}
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", justifyContent: "space-between" }}>
                            <p style={{ margin: 0, padding: 0, height: "24px" }}>Location Color</p>
                            <p style={{ color: 'grey', margin: 0, padding: 0, height: "24px", fontSize: 12 }}>{"(Optional)"}</p>
                        </Form.Label>

                        <Subtitle>Choose a color for this location</Subtitle>
                        <ColorPicker selectedColor={selectedColor} setSelectedColor={(color) => { setSelectedColor(color) }} />

                    </Col>
                </Row>

                {/* location details */}
                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex", marginTop: Spacing.SCALE_16 }}>
                    <p style={{ margin: 0, padding: 0, height: "24px" }}>Geofence Details</p>
                </Form.Label>
                <div style={{ height: isMobile ? 'auto' : '800px' }}>
                    <LiveLocationMap geofence={geofence} setGeofence={setGeofence} polygon={polygon} setPolygon={setPolygon} circularGeofence={circularGeofence} setCircularGeofence={setCircularGeofence} geofenceType={geofenceType} setGeofenceType={setGeofenceType} />
                </div>

                {/* confirm / cancel buttons */}
                <div style={{ marginTop: Spacing.SCALE_22 }}>
                    <Flex>
                        <Button variant="danger" onClick={handleCancelButton}>{"Cancel"}</Button>
                        <Button onClick={handleConfirm} variant={"primary"} style={{ marginLeft: Spacing.SCALE_8 }} disabled={title.length ? false : true}> {(addAirportLocationsStatus === "loading" || editAirportLocationsStatus === "loading") ? (<CustomSpinner />) : ("Confirm")}</Button>
                    </Flex>
                </div>

            </div >

        </div >
    )
}

export default HandleAirportLocationForm